const scene = "schedule/";
export const UPDATE_SCHEDULE_TYPE = `${scene}UPDATE_SCHEDULE_TYPE`;
export const UPDATE_PROGRESS = `${scene}UPDATE_PROGRESS`;